const RECORD_FIELDS = {};

export function recordFieldsForRecordType(recordType) {
  const RecordFieldClass = RECORD_FIELDS[`${recordType}Fields`];
  if (!RecordFieldClass) {
    throw new Error(
      `Invalid record type for record fields: ${JSON.stringify(recordType)}`
    );
  }

  return RecordFieldClass;
}

/**
 * Registers a RecordsField class.
 *
 * This is necessary to avoid loading all of the field definitions in our extensions code.
 *
 * @param {Record<string, typeof import('../RecordFields').default>} classes The class(es) to register.
 */
export function registerRecordFieldsClasses(classes) {
  Object.assign(RECORD_FIELDS, classes);
}
